import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { RuntimeEnvironmentService } from '@app/core/runtime-environment.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class GoogleTagManagerService {

  constructor(
    private runtimeEnvironmentService: RuntimeEnvironmentService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.setup();
  }

  private setup() {
    if (!isPlatformBrowser(this.platformId) || !this.runtimeEnvironmentService.googleTagManagerId) {
      return;
    }

    /* tslint:disable */
    (function (w, d, s, l, i) {
      w[ l ] = w[ l ] || [];
      w[ l ].push({
        'gtm.start':
          new Date().getTime(), event: 'gtm.js'
      });
      var f = d.getElementsByTagName(s)[ 0 ],
        j: any = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', this.runtimeEnvironmentService.googleTagManagerId);
    /* tslint:enable */
  }

}



// WEBPACK FOOTER //
// ./src/app/core/angulartics/google-tag-manager.service.ts